'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const LinkList = renderWithRef('LinkList', null, (s, t)=>jsx(RenderComp, {
        root: "ul",
        forwardedRef: t,
        classNames: [
            'swan-link-list'
        ],
        props: s,
        children: s.children
    }));

export { LinkList };
